import { ProgressTracker } from 'components/ProgressTracker';
import { SideBarLayout } from 'components/common';

export const ProgressTrackerLayout = () => (
  <SideBarLayout>
    <ProgressTracker/>
  </SideBarLayout>
);
